export const COOKIE_CONSENT_CONFIG = {
  name: '@Binamik:cookie_consentment',
  version: '1.0.0'
}
